module.exports = __webpack_public_path__ + "media/images/farmacias-d771e85610eb1afcc8f075de937786cc.svg";